import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { match } from "path-to-regexp";

import { allRoutes } from "../../system/routes";
import { USER_ROLE } from "../../system/global-enums";
import {
  hasUserAccess,
  hasAgentAccess,
  hasAdminAccess,
} from "../../shared/utility";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import AdminLayout from "../../layout/admin-layout/AdminLayout";
import Page404 from "../../views/404/Page404";

const PrivateRoute = ({ user, userRole, hasMultipleRoles, updateUserRole }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const isMultipleRoles = user?.roleIds?.length > 1;

  const routes = [...allRoutes(user, hasMultipleRoles)];

  // Match the current path against route patterns
  const currentRoute = routes.find((route) => {
    const matcher = match(route.path, { decode: decodeURIComponent });
    return matcher(location.pathname);
  });

  useEffect(() => {
    if (userRole === USER_ROLE.ADMIN || userRole === USER_ROLE.SUPER_ADMIN) {
      return;
    }
    if (
      currentRoute &&
      currentRoute.role !== userRole &&
      currentRoute.role !== USER_ROLE.ADMIN &&
      currentRoute.role !== USER_ROLE.SUPER_ADMIN &&
      hasMultipleRoles &&
      isMultipleRoles
    ) {
      updateUserRole(currentRoute.role, false);
    }
  }, [userRole, currentRoute]);

  // This useEffect ensures that the `isLoading` state is set to `false` when the component mounts.
  // It's used to simulate the completion of an initial loading process.
  useEffect(() => {
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <MainSpinner />;
  }

  return (
    <Routes>
      {hasUserAccess(userRole) &&
        routes
          .filter(
            (route) =>
              route.role === USER_ROLE.USER ||
              (hasMultipleRoles &&
                isMultipleRoles &&
                route.role === USER_ROLE.AGENT)
          )
          .map((route) => (
            <Route
              key={route.id}
              path={route.path}
              element={
                <route.component
                  {...(route?.isFromFavourites
                    ? { isFromFavourites: true }
                    : {})}
                />
              }
            />
          ))}
      {hasAgentAccess(userRole) &&
        routes
          .filter(
            (route) =>
              route.role === USER_ROLE.AGENT ||
              (hasMultipleRoles &&
                isMultipleRoles &&
                route.role === USER_ROLE.USER)
          )
          .map((route) => (
            <Route
              key={route.id}
              path={route.path}
              element={<route.component />}
            />
          ))}
      {hasAdminAccess(userRole) && (
        <Route element={<AdminLayout />}>
          {routes
            .filter((route) => route.role == USER_ROLE.ADMIN)
            .map((route) => (
              <Route
                key={route.id}
                path={route.path}
                element={<route.component />}
              />
            ))}
        </Route>
      )}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default PrivateRoute;
